import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "trigger", "panel" ]

  connect() {
    this.closeTimeout = null
  }

  disconnect() {
    this.clearCloseTimeout()
  }

  open() {
    this.clearCloseTimeout()
    this.panelTarget.classList.add("is-open")
    this.triggerTarget.classList.add("is-active")
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  scheduleClose() {
    this.clearCloseTimeout()
    this.closeTimeout = setTimeout(() => this.close(), 150)
  }

  cancelClose() {
    this.clearCloseTimeout()
  }

  close() {
    this.panelTarget.classList.remove("is-open")
    this.triggerTarget.classList.remove("is-active")
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  clearCloseTimeout() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout)
      this.closeTimeout = null
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
      this.triggerTarget.focus()
    }
  }
}
